var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalwareAnalysisServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.443848,
    y: 0.64624,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#43CB74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4636 38.1922V47.2551H26.3378V29.1292H32.8372C32.902 28.21 33.1221 27.3426 33.4587 26.5398H26.3378C24.9136 26.5398 23.7484 27.7051 23.7484 29.1292V47.2551C23.7484 48.6792 24.9136 49.8445 26.3378 49.8445H44.4636C45.8878 49.8445 47.0531 48.6792 47.0531 47.2551V40.7816L44.4636 38.1922ZM46.1468 32.8709C46.7164 31.9646 47.0531 30.9159 47.0531 29.7766C47.0531 26.5528 44.4507 23.9504 41.2269 23.9504C38.0031 23.9504 35.4007 26.5528 35.4007 29.7766C35.4007 33.0004 38.0031 35.6028 41.2139 35.6028C42.3533 35.6028 43.4149 35.2661 44.3083 34.6965L48.3478 38.7359L50.1862 36.8975L46.1468 32.8709ZM41.2269 33.0134C39.4402 33.0134 37.9901 31.5633 37.9901 29.7766C37.9901 27.9899 39.4402 26.5398 41.2269 26.5398C43.0136 26.5398 44.4636 27.9899 44.4636 29.7766C44.4636 31.5633 43.0136 33.0134 41.2269 33.0134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalwareAnalysisServiceIcon);
export default __webpack_public_path__ + "static/media/MalwareAnalysisServiceIcon.7c5542e8c6732a1bd1a68e8d7b7a16d1.svg";
export { ForwardRef as ReactComponent };